import { Box } from "@mui/material";
import {Component} from "react";
import * as React from "react";

interface IUploadImagePreviewProperties {
    file: any;
}

class UploadImagePreview extends Component<IUploadImagePreviewProperties, {}> {

    constructor(props: any) {
        super(props);
        this.state = {
            imageExistsLocally: true
        };
    }

    fetchImageBlob = async () => {
        try {
            await fetch(this.props.file.preview.url).then(r => r.blob());
        } catch (error) {
            this.setState({
                imageExistsLocally: false
            });
        }
    };

    componentDidMount() {
        this.fetchImageBlob();
    }

    render() {
        // @ts-ignore
        const { imageExistsLocally } = this.state;

        if(imageExistsLocally){
            return (
                <Box component={'img'} sx={{objectFit: "cover", width: 1, height: 1}} className="files-list-preview-image" src={this.props.file.preview.url} alt="Preview"/>
            );
        }else{
            return (
                <div className="files-list-preview-extension">{this.props.file.extension}</div>
            );
        }
    }
}

export default UploadImagePreview;